<div class="profile-card-container">
    <div class="initials"><span class="initials-text"> {{userInitials}} </span></div>
    <div class="user-info">
        <div class="user-name header2">Hi, {{user.name}}</div>
        <!-- <div *ngIf="user.businessFunction === 'dealeradmin'" class="user-title subtitle4">{{user.businessFunction}}</div> -->
    </div>
    <!-- <div class="pushed-charts" *ngIf="pushedCharts">
        {{pushedCharts.length}} Total Charts Pushed        
    </div> -->
    <!-- <app-charts-pushed-chart *ngIf="user.businessFunction === 'dealeradmin'"></app-charts-pushed-chart> -->
    <div class="option-buttons" *ngIf="user && user.isSuperAdmin"> 
        <div class="admin-card-button" routerLink="/reports/manage">
            <img class="admin-card-button-image" [src]="imgs[0].src" />
            <span class="admin-card-button-text">Manage Reports</span>
        </div>
        <!-- <div class="admin-card-button" (click)="openViewReportsOfDialog()">
            <img class="admin-card-button-image" [src]="imgs[1].src" />
            <span class="admin-card-button-text">View Reports Of</span>
        </div>
        <div class="admin-card-button"  routerLink="/admin/push-chart">
            <img class="admin-card-button-image" [src]="imgs[2].src"/>
            <span class="admin-card-button-text">Push Charts to Dealers</span>
        </div>
        <div class="admin-card-button" (click)="openViewAsDialog()">
            <img class="admin-card-button-image" [src]="imgs[3].src"/>
            <span class="admin-card-button-text">View Charts Of</span>
        </div> -->
    </div>
</div>